<ng-container *ngIf="valid">
  <ng-container *ngFor="let shape of forms; index as i">
    <mat-icon
      class="button without-stroke-width"
      [ngClass]="i | transform: getClassForIcon.bind(this)"
      [class.active]="selected === shape.title"
      [svgIcon]="shape.icon"
      [matTooltip]="shape.tooltip | translate"
      (click)="select(shape.title)"></mat-icon>
  </ng-container>
</ng-container>
